/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetBuildingCategoryOffersRequest,
  TGetBuildingCategoryOffersModel,
  IMappers,
  TGetBuildingCategoryOffersResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetBuildingCategoryOffersResponse } from '../../entities/entities/V1GetBuildingCategoryOffersResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetBuildingCategoryOffersModel(
  parameters: TGetBuildingCategoryOffersRequest,
): TGetBuildingCategoryOffersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'commercial-buildings',
    pathApi: '/v1/get-building-category-offers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetBuildingCategoryOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetBuildingCategoryOffersRequest;
}

export async function fetchGetBuildingCategoryOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetBuildingCategoryOffersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetBuildingCategoryOffersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetBuildingCategoryOffersModel(parameters),
    config,
  )) as FetchResponse<TGetBuildingCategoryOffersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetBuildingCategoryOffersResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetBuildingCategoryOffersResponse>;
}
